import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import { Button } from "components/common/button";
import { Field, FieldArray, reduxForm } from "redux-form";
import { CreatableSelect } from "components/common/select";
import { categoryType } from "custom-prop-types";
import { ActiveFilterItem } from "components/documents/filters/active-filter-item";
import styles from "components/documents/forms/assign-categories-form.scss";

const Form = (props) => (
  <div>
    <FieldArray
      component={
        renderFormContents(
          props.accountId,
          props.categories,
          props.onCancel,
          props.onCreateCategory,
          props.onSave,
          props.isLoading
        )
      }
      name="selectedCategories"
    />
  </div>
);

Form.propTypes = {
  accountId: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(categoryType).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onCreateCategory: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

const renderFormContents = (accountId, categories, onCancel, onCreateCategory, onSave, isLoading) => (props) => (
  <FormContents
    { ...props }
    accountId={ accountId }
    categories={ categories }
    isLoading={ isLoading }
    onCancel={ onCancel }
    onCreateCategory={ onCreateCategory }
    onSave={ onSave }
  />
);

const FormContents = ({
  accountId,
  categories,
  fields,
  isLoading,
  onCancel,
  onCreateCategory,
  onSave
}) => (
  <div>
    <CreatableSelect
      accountId={ accountId }
      createOption={ onCreateCategory }
      data={ mapCategories(categories, (fields.getAll() || [])) }
      onChange={ onChooseCategory(fields) }
      placeholder="Choose a category..."
    />
    <div className={ styles["selected-categories-container"] }>
      { renderNoSelection(R.propOr(0, "length")(fields.getAll()), onSubmitCategories(fields, onCancel, onSave)) }
      { fields.map((fieldName, index) => renderCategory(fieldName, index, fields)) }
    </div>
    <div className={ styles.actions }>
      <Button link onClick={ () => { fields.removeAll(); onCancel(); } }>cancel</Button>
      <Button
        disabled={ R.propOr(0, "length")(fields.getAll()) === 0 }
        loading={ isLoading }
        onClick={ onSubmitCategories(fields, onCancel, onSave) }
        primary
      >
        Save
      </Button>
    </div>
  </div>
);

const onSubmitCategories = (fields, onCancel, onSave) => () => {
  onSave()
    .then(() => {
      fields.removeAll();
      onCancel();
    });
};

const renderNoSelection = (selectionCount, onSave) => {
  if (selectionCount !== 0) {
    return null;
  }
  return (
    <div className={ styles["no-selection"] } >
      No categories selected
      <div className={ styles["no-selection--actions"] }>
        <Button danger link onClick={ onSave }>Remove existing categories</Button>
      </div>
    </div>
  );
};

FormContents.propTypes = {
  accountId: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(categoryType).isRequired,
  fields: PropTypes.shape({
    getAll: PropTypes.func,
    push: PropTypes.func
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onCreateCategory: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

const mapCategories = (categories, selectedNames) => (
  categories
    .filter(category => !selectedNames.includes(category.name))
    .map(mapCategory)
);

const mapCategory = (category) => ({ key: category.name, name: category.name });

const onChooseCategory = (fields) => ({ name }) => {
  if (fields.getAll() === undefined) {
    fields.push(name);
    return;
  }

  if (!fields.getAll().includes(name)) {
    fields.push(name);
  }
};


const renderCategory = (fieldName, index, fields) => {
  const fieldContents = ({ input: { value } }) => (
    <div className={ styles["selected-item-container"] }>
      <ActiveFilterItem
        name={ value }
        onRemove={ () => { fields.remove(index); } }
      />
    </div>
  );

  fieldContents.propTypes = {
    input: PropTypes.shape({ value: PropTypes.string }).isRequired
  };

  return (
    <span key={ fieldName }>
      <Field
        component={ fieldContents }
        name={ fieldName }
      />
    </span>
  );
};

export const AssignCategoriesForm = reduxForm({
  destroyOnUnmount: false,
  form: "batchCategoriesForm",
  keepDirtyOnReinitialize: true
})(Form);



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/forms/assign-categories-form.jsx